.sortTrigger {
	display: none;
	color: var(--ds-text-subtlest, var(--adg3-color-N50));
	background: transparent;
	outline: none;
	width: 24px;
	align-items: center;
	justify-content: center;
	cursor: pointer;

	&:hover {
		color: var(--ds-text-subtlest, var(--adg3-color-N70));
		background: var(--ds-background-neutral, var(--adg3-color-N30));
	}
}

.sortTrigger.active {
	display: flex;
	color: var(--ds-text, var(--adg3-color-N800));
}

.isDisabled {
	cursor: not-allowed;
}

.paddingOld {
	padding: var(--jpo-common-base-spacing);
}
